import * as React from "react"
import {withRouter} from "react-router"

interface OwnProps {
  location: Location
}

// From https://reacttraining.com/react-router/web/guides/scroll-restoration
class ScrollToTop extends React.Component<OwnProps, {}> {
  componentDidUpdate(prevProps: OwnProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0)
    }
  }

  render() {
    return null
  }
}

export default withRouter(ScrollToTop as any)



// WEBPACK FOOTER //
// ./src/components/ScrollToTop.tsx